import { RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  time_labels: {
    today: 'Heute',
    asap: 'ASAP',
    scheduled: '{{date}}, {{time}}',
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Zimmernummer',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Tischnummer',
  },
};
